export default __webpack_public_path__ + "static/media/rpms-ehr-logo.7dc38d19.png";